import type { Models } from "appwrite";

export interface AdditionalEquipmentItem {
    nombre: string;
    serial: string;
    modelo: string;
    estado: string;
    descripcion: string;
}

export interface CredentialItem {
    username: string;
    password: string;
}

// Serialization helpers
export const parseAdditionalEquipment = (items: string[]): AdditionalEquipmentItem[] =>
    items.map(item => {
        try { return JSON.parse(item) as AdditionalEquipmentItem }
        catch { return { nombre: item, serial: "", modelo: "", estado: "", descripcion: "" } }
    })

export const parseCredentials = (items: string[]): CredentialItem[] =>
    items.flatMap(item => {
        try { return [JSON.parse(item) as CredentialItem] }
        catch { return [] }
    })


export interface Instrument extends Models.Document {
    serialNumber: string;
    model: string | null;
    idOrganization: string | null;
    equipmentName: string | null;
    idBrand: string | null;
    manufactureYear: number | null;
    voltage: string | null;
    current: string | null;
    softwareVersion: string | null;
    equipmentDescription: string | null;
    additionalEquipment: string[];
    equipmentType: string | null;
    status: string | null;
    location: string | null;
    clientAssetCode: string | null;
    correoNotificacionResponsable: string | null;
    correoCliente: string | null;
    idFiles: string[] | null;
    idQrFile: string | null;
    credentials: string[] | null;
}

export interface InstrumentForm {
    serialNumber: string;
    model: string | null;
    idOrganization: string | null;
    equipmentName: string | null;
    idBrand: string | null;
    manufactureYear: number | null;
    voltage: string | null;
    current: string | null;
    softwareVersion: string | null;
    equipmentDescription: string | null;
    additionalEquipment: string[];
    equipmentType: string | null;
    status: string | null;
    location: string | null;
    clientAssetCode: string | null;
    correoNotificacionResponsable: string | null;
    correoCliente: string | null;
    idFiles: string[];
    idQrFile: string | null;
    credentials: string[];
}